export default __webpack_public_path__ + "static/media/ContactCardsWatchQRYellow.82210853.png";